import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['trigger', 'forced']
  static values = {
    forced: String,
  }

  declare triggerTarget: HTMLSelectElement
  declare forcedTarget: HTMLSelectElement
  declare forcedValue: string

  connect() {
    this.update()
  }

  update(): void {
    if (this.triggerTarget.value !== '') {
      this.forcedTarget.value = this.forcedValue
      this.forcedTarget.disabled = true
    } else {
      this.forcedTarget.disabled = false
    }
  }

  // NOTE: disabledなselect要素はフォーム送信時にパラメータとして送信されないため、submit直前にdisabledを解除して値が送信されるように
  enableBeforeSubmit(): void {
    this.forcedTarget.disabled = false
  }
}
